import classNames from "../classNames";
import dialog from "../Modal/dialog";

const defaultProps = {
  title: "Discard Changes",
  icon: "bi bi-exclamation-octagon-fill",
  message: "If you leave the page, any changes that you made will be lost.",
};

function DiscardDialog({ title, icon, message, onConfirm }) {
  return (
    <div className="p-4">
      <div className="d-flex flex-column text-center gap-2">
        <i
          className={classNames(icon)}
          style={{ fontSize: "3rem", color: "#14213D" }}
        ></i>
        <h2 className="fw-bold">{title}</h2>
        <p className="fs-6 m-0" style={{ lineHeight: "1.2rem" }}>
          {message}
        </p>
        <div className="d-flex mt-3 gap-2">
          <button
            className="btn w-50"
            style={{ backgroundColor: "#DADBE0" }}
            onClick={() => dialog.close()}
          >
            Cancel
          </button>
          <button
            className="w-50 rounded-2 text-white"
            style={{ backgroundColor: "#14213D" }}
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

DiscardDialog.defaultProps = defaultProps;
export default DiscardDialog;
